import styled from "styled-components";

export const StyledConfirmation = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;

  label {
    cursor: pointer;
  }
`;

StyledConfirmation.displayName = "StyledConfirmation";
